let generateFullAddress = ( apart, house = null, config ) => {
  if (!apart) return '';
  let building = house ? house : (apart.address && apart.address[0] ? apart.address[0] : {});
  let city = building.city ? `г. ${building.city}, ` : '';
  let street = building.street ? `${building.street}` : '';
  let houseText = building.house ? `${building.house},` : '';
  let apartNumber = apart.type_apart === 0 ? `кв. ${apart.number}` : `пом. ${apart.number}`;

  if (config) {
    const { withoutCity } = config;
    if (withoutCity) city = '';
  }

  return `${city}${street} ${houseText} ${apartNumber}`;
};

export default generateFullAddress;
